import {
  DriveSourceTargetEventMessage,
  DriveSourceTargetEventType,
  EventMessage,
  EventType,
  WebSocketContext,
} from 'contexts/WebSocketContext';
import { useObservable } from 'observable-hooks';
import { useContext } from 'react';
import { Observable } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

const eventIsDriveSourceTargetEvent = (
  event: EventMessage
): event is DriveSourceTargetEventMessage =>
  event.type === EventType.FileEvent &&
  (event.event === DriveSourceTargetEventType.Added ||
    event.event === DriveSourceTargetEventType.Removed);

const maybeHasProjectDriveId =
  (projectDriveId?: string) =>
  (event: DriveSourceTargetEventMessage): boolean =>
    projectDriveId !== undefined && event.driveid === projectDriveId;

const useDriveSourceTargetEvents = (
  projectDriveId?: string
): Observable<DriveSourceTargetEventMessage> => {
  const { receive } = useContext(WebSocketContext);

  return useObservable(
    (state$: Observable<[Observable<EventMessage>]>) =>
      state$.pipe(
        mergeMap(([rcv]) => rcv),
        filter(eventIsDriveSourceTargetEvent),
        filter(maybeHasProjectDriveId(projectDriveId))
      ),
    [receive()]
  );
};

export default useDriveSourceTargetEvents;
